import { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
// import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { tap } from 'rxjs/operators';

export const authInterceptorFn: HttpInterceptorFn = (req, next) => {
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${(inject(AuthService)).getToken()}`
    }
  });
  return next(authReq)
  .pipe( // TODO: Kann auch deaaktiviert werden, wenn es Probleme macht.
        tap(
          (_response: HttpEvent<any>) => {},
          (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                // if the request is unauthorized,
                // make the user log in again
                inject(AuthService).logout();
              }
            }
          }
        )
      );
};